import { useParams } from 'react-router-dom';
import GroupRailLayout from '@/features/groupRail/GroupRailLayout';
import SheetListPane from './SheetListPane';
import SheetDetailPane from './SheetDetailPane';

/**
 * Sign-up sheets workspace: cross-org group rail + content pane.
 * Routes: /signups (auto-select), /signups/:groupId, /signups/:groupId/s/:sheetId.
 */
export default function SignupsLayout() {
  const { groupId, sheetId } = useParams();

  return (
    <GroupRailLayout
      basePath="/signups"
      lastViewKey="flock_signups_last_view"
      collapseKey="flock_signups_sidebar_collapsed"
      emptyHint="Select a group to see its sign-up sheets."
      selectedGroupId={groupId ?? null}
      renderContent={(group) =>
        sheetId ? (
          <SheetDetailPane key={sheetId} group={group} sheetId={sheetId} />
        ) : (
          <SheetListPane key={group.id} group={group} />
        )
      }
    />
  );
}
